module.exports = __webpack_public_path__ + "img/posture_perfect2.cdd4c1b3.png";